import {
  Flex, Container, Heading, Text, Button, Box, Image,
} from '@chakra-ui/react';
import StageBookLogo from '@/assets/stagebook_logo.webp';
import ErrorBoundaryImage from '@/assets/error_boundary.svg';

const Generic = () => {
  const handleGoHome = () => {
    window.location.href = '/painel/agendas';
  };

  return (
    <Container maxW="5xl" py={10}>
      <Flex direction="column" align="center" gap={3}>
        <Image src={StageBookLogo} alt="StageBook Logo" width={180} />

        <Image
          src={ErrorBoundaryImage}
          alt="Erro na aplicação"
          width={{ base: '100%', md: 400 }}
        />

        <Box textAlign="center" mt={4}>
          <Heading>
            Oops... Parece que algo deu errado!
          </Heading>
          <Text>
            Não se preocupe, estamos trabalhando para resolver o problema.
          </Text>
        </Box>

        <Button size="sm" mt={4} bg="primary.500" onClick={handleGoHome}>
          Voltar para a página inicial
        </Button>
      </Flex>
    </Container>
  );
};

export default Generic;
